import { motion, useScroll, useTransform } from 'framer-motion';

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[3px]" style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}>
      <motion.div
        data-testid="scroll-progress"
        className="h-full origin-left"
        style={{ backgroundColor: '#F7E600', scaleX }}
      />
    </div>
  );
}
